// extracted by mini-css-extract-plugin
export default {"colorText":"Iha-z","colorTextLabel":"Jha-z","colorTextValue":"Kha-z","swatches":"Lha-z","collapseLink":"Mha-z","isCollapsed":"Nha-z","dropdown":"Oha-z","disabled":"Pha-z"};